// extracted by mini-css-extract-plugin
module.exports = {"day-filter":"ScheduleListEmbed_day-filter__LskMl"};